import { render, staticRenderFns } from "./Persona.vue?vue&type=template&id=7be38a5d&lang=pug&"
import script from "./Persona.vue?vue&type=script&lang=ts&"
export * from "./Persona.vue?vue&type=script&lang=ts&"
import style0 from "./Persona.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Persona.vue"
export default component.exports